import useAuth from '@/hooks/useAuth';
import * as config from "../config";
import axios, { AxiosResponse } from 'axios';
import { University } from './useUniversities';

export const useSaveFavorites = () => {
  const { user } = useAuth();
  const token = user?.token;

  const headers = {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "Authorization": `Bearer ${token}`,
  };

  const save = async (favorites: University[]): Promise<AxiosResponse<any>> => {
    if (!token) {
      return Promise.reject('No token available');
    }

    const url = `${config.apiConfig.host}/favorites`;
    return axios.post(url, { favorites }, { headers });
  };

  return { save };
};
